import * as yup from "yup";
import { FilterViewModel } from "api/factories/ulits.factory";

export interface CreativeMappingsRuleForm {
    id?: number;
    isEdited?: boolean;
    filters: FilterViewModel[];
    creatives: CreativesViewModel[];
}

export interface CreativesViewModel {
    width: string;
    height: string;
    target: string;
}

export const createDefaultCreativeMappingFormValues: CreativeMappingsRuleForm = {
    filters: [{ name: "", operator: "", logicalOperator: "" }],
    creatives: [
        {
            height: "",
            width: "",
            target: "",
        },
    ],
};

export const creativeMappingsSchema = yup.object().shape({
    creatives: yup
        .array()
        .min(1)
        .of(
            yup.object().shape({
                width: yup
                    .string()
                    .required("Width is required")
                    // eslint-disable-next-line
                    .min(1, "Width must be greater than ${min}"),
                height: yup
                    .string()
                    .required("Height is required")
                    // eslint-disable-next-line
                    .min(1, "Height must be greater than ${min}"),
                target: yup.string(),
            })
        ),
    filters: yup
        .array()
        .min(1)
        .of(
            yup.object().shape({
                name: yup.string().required("Field is required"),
                operator: yup.string().required("Operator is required"),
                options: yup
                    .array()
                    // eslint-disable-next-line
                    .min(1, "Value field must have at least ${min} item")
                    .of(
                        yup.object().nullable().required("Value is required").default({}).shape({
                            name: yup.string(),
                            value: yup.string(),
                        })
                    ),
                logicalOperator: yup.string(),
            })
        ),
});
